import { Store } from "@bryntum/schedulerpro";
import { Team } from "../models/Team";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

const onRemoveTeamFromEntity = (stores, records) => {
  // _team field is using teamId field to look up record from the store. In this listener we
  // already have that record removed. Thus, we need to perform lookup by the id itself.
  records = records.map(r => r.id);

  stores.forEach((store) => {
    store.forEach((storeModel) => {
      if (records.includes(storeModel.teamId)) {
        storeModel._team = null;
      }
    }, null, {
      includeFilteredOutRecords: true,
      includeCollapsedGroupRecords: true
    });
  }, null, {
    includeFilteredOutRecords: true,
    includeCollapsedGroupRecords: true
  })
}

const onUpdateTeamOnEntity = (stores, record) => {
  stores.forEach((store) => {
    store.forEach((storeModel) => {
      if (storeModel.teamId === record.id) {
        storeModel._team = record;
      }
    }, null, {
      includeFilteredOutRecords: true,
      includeCollapsedGroupRecords: true
    });
  }, null, {
    includeFilteredOutRecords: true,
    includeCollapsedGroupRecords: true
  });
}

export class SwivuTeamStore extends Store {

  static get configurable() {
    return {
      id: STORE_KEYS.boardTeamsStore,
      storeId: STORE_KEYS.boardTeamsStore,
      modelClass: Team,
      useSparseIndex: true,
    }
  }

  onUpdate({ record, changes }) {
    const project = this.project || record.project;
    if (project) {
      const { resourceStore, clientsStore, extraTaskStore } = project;

      // Only update related records if name, color (or id) is changed, it will update cached team name
      if ('name' in changes || 'id' in changes || 'color' in changes) {
        onUpdateTeamOnEntity([resourceStore, clientsStore, extraTaskStore], record);
      }

      // If group order is changed, we need to regroup the store
      if ('order' in changes) {
        const resourceGroup = resourceStore.groupers?.find(r => r.field === 'teamValue');
        const taskGroup = extraTaskStore.groupers?.find(r => r.field === 'teamValue');
        const clientGroup = clientsStore.groupers?.find(r => r.field === 'teamValue');
        if (resourceGroup) resourceStore.group(resourceGroup);
        if (taskGroup) extraTaskStore.group(taskGroup);
        if (clientGroup) clientsStore.group(clientGroup);
      }
    }
  }

  onRemove({ records }) {
    const project = this.project || records?.[0]?.project;
    if (project) {
      onRemoveTeamFromEntity([project.resourceStore, project.clientsStore, project.extraTaskStore], records);
    }
  }
}
